import { Directive, EventEmitter, Output } from '@angular/core';
import { BaseModal } from '../base/base-modal';
import { PropertyUpdateSynchronisationInfo } from '../../../../shared/models/entity-property-info/property-update-synchronisation-info';
import { Step } from '../../../../shared/models/internal/step';
import { EntityPropertyUpdatePropagationInfo } from '../../../../shared/models/entity-property-info/internal/entity-property-update-propagation-info';
import { PropertyUpdateInfo } from '../../../../services/api/base/property-update-info';

@Directive()
export abstract class PropagateChangesToEntitiesInOtherVersionsModalBase<T> extends BaseModal {
  @Output() public changesConfirmed = new EventEmitter<EntityPropertyUpdatePropagationInfo[]>();
  @Output() public notPropagateChanges = new EventEmitter<void>();

  protected propertyUpdateInfo?: PropertyUpdateSynchronisationInfo;
  protected abstract readonly propertyUpdateInfoApi: PropertyUpdateInfo<T>;

  private updatedInfo?: PropertyUpdateSynchronisationInfo;

  private _steps: Step[] = [];

  public override openModal(pendingEntity?: T): void {
    if (pendingEntity) {
      this.fetchPropertyUpdateInfo(pendingEntity);
    }
  }

  public override closeModal(): void {
    super.closeModal();
    this.propertyUpdateInfo = undefined;
    this.updatedInfo = undefined;
    this._steps = [];
  }

  protected get steps(): Step[] {
    return this._steps;
  }

  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  protected get agentBusinessObject(): string {
    return 'entity';
  }

  protected onPropertyInfosUpdated(updatedInfo: PropertyUpdateSynchronisationInfo): void {
    this.updatedInfo = updatedInfo;
  }

  protected confirmChanges(): void {
    if (this.updatedInfo) {
      this.changesConfirmed.emit(this.updatedInfo.getPropertyUpdatePropagationInfo());
    } else if (this.propertyUpdateInfo) {
      this.changesConfirmed.emit(this.propertyUpdateInfo.getPropertyUpdatePropagationInfo());
    }
    this.closeModal();
  }

  private fetchPropertyUpdateInfo(pendingEntity: T): void {
    this.propertyUpdateInfoApi.getPropertyUpdateInfo(pendingEntity).subscribe({
      next: (response) => {
        this.handleEntityEditAndToggleModal(response);
      },
      error: (err) => {
        console.error('Error fetching property update info:', err);
      },
    });
  }

  private initSteps(): void {
    this._steps = [];
    const numberOfSteps = this.propertyUpdateInfo?.steps || 0;
    for (let i = 1; i <= numberOfSteps; i++) {
      this._steps.push({ label: this.propertyUpdateInfo?.getFieldNameForStep(i) || '', index: i, isActive: i === 1 });
    }
  }

  private handleEntityEditAndToggleModal(propertyUpdateSynchronisationInfo: PropertyUpdateSynchronisationInfo): void {
    if (
      propertyUpdateSynchronisationInfo.isOnlyEntityEditedAffected ||
      !propertyUpdateSynchronisationInfo.anyFieldsAffected
    ) {
      this.notPropagateChanges.emit();
    } else {
      this.propertyUpdateInfo = propertyUpdateSynchronisationInfo;
      this.initSteps();
      super.openModal();
    }
  }
}
